import React, { useState } from 'react';
import { Button, Drawer, Dropdown, Space, Menu } from 'antd';
import { DownOutlined, LeftOutlined, RightOutlined, UserOutlined } from '@ant-design/icons';
import CustomSwitch from '../Switch';
import './CustomDrawer.scss';

interface DrawerItem {
  temporaryLayerName: string;
}

interface CustomDrawerProps {
  drawerItems: DrawerItem[];
}

interface MenuItem {
  label: string;
  key: string;
  icon: React.ReactNode;
}

const items: MenuItem[] = [
  {
    label: '1st menu item',
    key: '1',
    icon: <UserOutlined />,
  },
  {
    label: '2nd menu item',
    key: '2',
    icon: <UserOutlined />,
  },
  {
    label: '3rd menu item',
    key: '3',
    icon: <UserOutlined />,
  },
  {
    label: '4th menu item',
    key: '4',
    icon: <UserOutlined />,
  },
];

const CustomDrawer: React.FC<CustomDrawerProps> = ({ drawerItems }) => {
  const [open, setOpen] = useState(false);
  // @ts-ignore
  const [dropDownText, setDropDownText] = useState('Legend Item 1');

  // @ts-ignore
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleMenuClick = (e: any) => {
    const selectedItem = items.find((item) => item.key === e.key);
    if (selectedItem) {
      setDropDownText(selectedItem.label);
    }
  };

  // @ts-ignore
  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const drawerWidth = 300;

  return (
    <>
      <Button
        style={{
          position: 'absolute',
          right: open ? drawerWidth : 0,
          top: '48%',
          width: '10px',
          textAlign: 'center',
          cursor: 'pointer',
        }}
        onClick={() => setOpen(!open)}
      >
        <div style={{ marginLeft: '-0.4rem', cursor: 'pointer' }}>{open ? <RightOutlined /> : <LeftOutlined />}</div>
      </Button>

      {!open && (
        <div
          style={{
            position: 'absolute',
            right: 0,
            height: '50%',
            width: '3px',
            backgroundColor: 'white',
            marginTop: '8rem',
            marginBottom: '8rem',
          }}
        />
      )}

      <Drawer
        onClose={onClose}
        open={open}
        placement="right"
        getContainer={false}
        closeIcon={false}
        width={drawerWidth}
        style={{
          height: '60%',
          marginTop: '8rem',
          marginBottom: '8rem',
        }}
      >
        {drawerItems.map((item, index) => (
          <div key={index} style={{ display: 'flex' }}>
            <CustomSwitch />
            <Dropdown overlay={<Menu onClick={handleMenuClick} />}>
              <Button
                style={{
                  marginLeft: '2rem',
                  marginBottom: '2rem',
                  backgroundColor: '#076169',
                  color: 'white',
                  borderColor: '#076169',
                  width: '70%',
                }}
              >
                <Space>
                  {item.temporaryLayerName}
                  <DownOutlined />
                </Space>
              </Button>
            </Dropdown>
          </div>
        ))}
      </Drawer>
    </>
  );
};

export default CustomDrawer;
